// Foundations
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentCreditCard } from 'src/app/models/payment/payment-card.model';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';

const ACTIVE_RADIO_PATH = 'assets/svg/ico_check_solid.svg';
const INACTIVE_RADIO_PATH = 'assets/svg/ico_circle_selection_white.svg';

@Component({
  selector: 'app-payment-tile',
  templateUrl: './payment-tile.component.html',
  styleUrls: ['./payment-tile.component.scss'],
})
export class PaymentTileComponent implements OnInit {
  // #region -> Property <-
  // ----------

  @Input() creditCard: PaymentCreditCard;
  @Input() selectedCreditCard: PaymentCreditCard;
  @Output() selectedChange = new EventEmitter<PaymentCreditCard>();

  @Input() showRadio = false;
  @Input() showChange = false;
  @Output() toChange = new EventEmitter();

  @Input() readOnly = false;
  @Output() toEdit = new EventEmitter<string>();
  @Output() toDelete = new EventEmitter<PaymentCreditCard>();

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Constructor <-
  // ----------

  constructor(private _analytics: AnalyticsService) {}

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Lifecycle <-
  // ----------

  ngOnInit(): void {}

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Method <-
  // ----------

  get getRadioPath() {
    if (this.creditCard && this.selectedCreditCard) {
      return this.creditCard.id === this.selectedCreditCard.id
        ? ACTIVE_RADIO_PATH
        : INACTIVE_RADIO_PATH;
    }

    return INACTIVE_RADIO_PATH;
  }

  onEditPayment() {
    this._analytics.logButtonTap('paymentList_editPayment');
    this.toEdit.emit(this.creditCard.id);
  }

  onDeletePayment() {
    this._analytics.logButtonTap('paymentList_removePayment');
    this.toDelete.emit(this.creditCard);
  }

  onChangePayment() {
    this.toChange.emit();
  }

  handleSelect() {
    if (this.showRadio) {
      this.selectedChange.emit(this.creditCard);
    }
  }

  // ----------
  // #endregion

  /////////////////////////////
}
